import { Heading, Text, Container } from '@chakra-ui/react';

export default function TitleText({
  titleText,
}: {
  titleText: {
    title: string;
    text: string;
  };
}) {
  return (
    <Container my={{ base: '14', lg: '24' }}>
      <Heading
        as="h4"
        fontSize={{ base: '1.75rem', lg: '2rem' }}
        lineHeight={{ base: '2rem', lg: '2.25rem' }}
      >
        {titleText.title}
      </Heading>
      <Text mt={{ base: '6', lg: '8' }}>{titleText.text}</Text>
    </Container>
  );
}
